import { formatDate } from '@/service/dateFormatting.service';

export default {
  name: 'formatDate',
  fn(value, customLabel) {
    return value ? formatDate(value) : customLabel ?? 'Unknown';
  },
};
